import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LoginServicesService } from '../shared/services/login-services.service';
// import * as $ from 'jquery';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { AppService } from '../shared/services/app.service';
declare var $: any;

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
})
export class RegisterComponent implements OnInit {
  user: any = { name: 'Avinash', password: 'stag@123', platform: 'dosmartqa' };
  language: any = 'en';
  languages: any = [
    { short: 'en', fullform: 'English' },
    // { short: 'jp', fullform: 'Japanese' },
  ];
  password: any = { newPassword: '', confirmPassword: '' };
  register: any = {
    firstname: '',
    lastname: '',
    emailId: '',
    organization: '',
    password: '',
    confirmPassword: '',
    verified: '',
    groupToken: '',
    // "profile": '',
  };
  toastMsg: any = '';
  toastMsgResendVerify: any = '';
  resendEmailID: any = '';
  slideTimeOut: any;
  resetPassword: any;
  userID: any;
  errors: any = [];
  usrVerified: any = 0;
  isOrgDisabled: any = false;
  isGroupDisabled: any = false;
  groupToken: any;
  verifyUsrID: any;
  confirmMsgShow: any = false;
  disLoginBtn: any = false;
  disRegisterBtn: any = false;
  publicToken: any;
  verifyUsrIDNew: any;
  usrVerifiedNew: any;
  groupTokenNew: any;
  isOrgDisabledNew: any;
  userIDNew: any;
  constructor(
    public translate: TranslateService,
    private router: Router,
    private loginService: LoginServicesService,
    private cookieService: CookieService,
    private AppService: AppService
  ) {
    // translate.addLangs(["en", "jp"]);
    translate.setDefaultLang('en');
    this.cookieService.delete('language');
    this.cookieService.set('language', this.language);
    const browserLang = translate.getBrowserLang();
    translate.use(browserLang.match(/en|jp/) ? browserLang : 'en');
  }

  ngOnInit(): void {
    // this.user = { "name": '', "password": '', "platform":'dosmartqa' };
    var uri = window.location.toString();
    if (uri.indexOf("?") > 0) {
      var queryStr = decodeURIComponent(window.location.href);
      var qStrData = queryStr.split("?")[1].split("=")[0];
      var qStrData1 = queryStr.split("?")[1].split("=")[1];

      if (qStrData1.indexOf("&expirylink") != -1) {
        qStrData1 = qStrData1.split("=")[0].split("&expirylink")[0];
      }
      // if (queryStr.indexOf("&expirylink") != -1) {
      //   let qStrData2 = queryStr.split("&expirylink")[1].split("=")[1];
      // }
      if (queryStr.indexOf("&") > 0) {
        let qStrVal = queryStr.split("?")[1].split("=")[1].split("&")[0];
        let qStrData1 = queryStr.split("&")[1].split("=")[1];
        if (qStrVal) {
          if (qStrData == 'id') {
            this.verifyUsrIDNew = qStrVal;
            this.verifyEmailLink();
          } else if (qStrData == 'token') {
            $('#emailInputField').hide();
            $('#orgInputField').hide();
            this.usrVerified = 1;
            this.groupToken = qStrVal;
            this.register.organization = qStrData1;
            this.isOrgDisabledNew = true;
          } else if (qStrData == 'userId') {
            this.userIDNew = qStrVal;
          }
        }
      } else {
        if (qStrData == 'id') {
          this.verifyUsrIDNew = qStrData1;
          this.verifyEmailLink();
        } else if (qStrData == 'userId') {
          this.userIDNew = qStrData1;
        }
      }
    }
    // console.log("this.groupToken",this.groupToken);
    // console.log("this.register.organization",this.register.organization);
    // console.log("this.groupToken",this.groupToken);
  }

  verifyEmailLink() {

  }
  registerFormSubmit = (register: any) => {
    // var usrVerified;
    // var groupToken;
    if (this.usrVerified == 1) {
      if (
        !register.firstname ||
        !register.lastname ||
        !register.username ||
        !register.password ||
        !register.confirmPassword
      ) {
        this.triggerToast(this.AppService.getResourceText('V007'));
        return;
      }
    }
    if (this.usrVerified == 0) {
      if (
        !register.firstname ||
        !register.lastname ||
        !register.emailId ||
        !register.username ||
        !register.password ||
        !register.confirmPassword ||
        !register.organization
      ) {
        this.triggerToast(this.AppService.getResourceText('V007'));
        return;
      } else if (!this.validateEmailID(register.emailId)) {
        this.triggerToast(this.AppService.getResourceText('V008'));
        return;
      }
    }
    if (register.password != register.confirmPassword) {
      this.triggerToast(this.AppService.getResourceText('V009'));
      return;
    } else if (
      this.validatePassword(register.password) &&
      this.errors.length != 0
    ) {
      if (this.errors.length > 0) {
        this.triggerToast(this.errors.join('<br>'));
        return;
      }
    } else {
      register.verified = this.usrVerified;
      if (this.groupToken != '') {
        register.groupToken = this.groupToken;
      }
      this.disRegisterBtn = true;
      this.loginService.registerUser(register).subscribe(
        (response: any) => {
          this.disRegisterBtn = true;
          // console.log(response);
          if (response.statusCode == 200) {
            this.triggerToast(this.AppService.getResourceText('B007'));
            setTimeout(function () {
              window.location.href = '/login';
            }, 3000);
          } else if (response.statusCode == 201) {
            this.verifyUsrID = response.login_refId;
            this.verifyEmailLinkforInvNonExistUser();
          } else if (response.statusCode == 206) {
            this.disRegisterBtn = false;
            this.triggerToast(this.AppService.getResourceText('B010'));
          } else if (response.statusCode == 207) {
            this.disRegisterBtn = false;
            this.triggerToast(this.AppService.getResourceText('B009'));
          } else if (response.statusCode == 208) {
            this.disRegisterBtn = false;
            this.triggerToast(this.AppService.getResourceText('B008'));
          } else if (response.statusCode == 500) {
            this.disRegisterBtn = false;
            this.triggerToast(this.AppService.getResourceText('B002'));
          } else {
            this.triggerToast(response);
          }
        });
    }
  };

  verifyEmailLinkforInvNonExistUser() {
    if (this.verifyUsrID != "" && this.verifyUsrID != undefined && this.verifyUsrID != null) {
      var obje = {
        'link': 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.IjIwMTktMTItMTFUMDk6MzI6NDQuMTIyWiI.qF4qvjCHxjFLUpkrq4NEyp_ysq8FyKpV90TKn49NXd4',
        'registerRefId': this.verifyUsrID
      }
      this.loginService.verifyEmailExpiryLink(obje).subscribe(
        (response: any) => {
          // console.log(response);
          if (response.statusCode === 200) {
            this.confirmMsgShow = true;
            var invitesArray = response.invites;
            this.emailVerifyforInvNonExistUser(this.verifyUsrID, invitesArray);
          } else if (response.statusCode === 401) {
            this.confirmMsgShow = true;
            this.triggerToast(this.AppService.getResourceText("B018"));
          } else if (response.statusCode === 500) {
            this.triggerToast(this.AppService.getResourceText("B002"));
          } else {
            this.triggerToast(this.AppService.getResourceText("B002"));
          }
        });

    }
  }


  emailVerifyforInvNonExistUser(id: any, invArray: any) {
    let emailId = { "id": id, "invites": invArray };
    this.loginService.emailVerification(emailId).subscribe(
      (response: any) => {
        // console.log(response);
        if (response.statusCode === 200) {
          this.triggerToast(this.AppService.getResourceText("B023"));
          setTimeout(() => { window.location.href = "/login" }, 3000);
        } else if (response.statusCode === 500) {
          this.triggerToast(this.AppService.getResourceText("B002"));
        } else {
          this.triggerToast(this.AppService.getResourceText("B002"));
        }
      });


  }


  // Function to validate the EMAIL regix
  validateEmailID(email: any) {
    var re = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/i;
    return re.test(email);
  }
  // Function to validate the PASSWORD regix

  validatePassword(password: any) {
    this.errors = [];

    if (
      password.length < 8 ||
      password.search(/[a-z]/i) < 0 ||
      password.search(/[0-9]/) < 0 ||
      password.search(/[!@#$%^&*]/) < 0
    ) {
      this.errors.push(this.AppService.getResourceText("V023"));
    }
    return this.errors;
  }

  resendEmailVerifyLink = (emailID: any) => {
    console.log("emailID", emailID);
    if (!emailID) {
      this.triggerToastResendVerify("Field's can't be empty.");
      return;
    } else if (!this.validateEmailID(emailID)) {
      this.triggerToastResendVerify("Invalid email ID.");
      return;
    } else {
      this.loginService.resendEmailverifylink({ emailId: emailID }).subscribe(
        (response: any) => {
          // console.log('response success', response);
          if (response.statusCode === 200) {
            this.triggerToastResendVerify("Please check your email to verify mail.");
            this.resendEmailID = '';
          } else if (response.statusCode === 201) {
            this.triggerToastResendVerify(
              "User already verified."
            );
          } else if (response.statusCode === 202) {
            this.triggerToastResendVerify(
              "User does not exist."
            );
            this.resendEmailID = '';
          }
        },
        (response: any) => {
          // console.log('response error', response);
          this.triggerToastResendVerify(response);
        }
      );
    }
  };
  triggerToast(message: string) {
    this.toastMsg = message;
    $('#snackbar').html(message);
    var x: any = document.getElementById('snackbar');
    x.className = 'show';
    setTimeout(function () {
      x.className = x.className.replace('show', '');
    }, 3000);
  }

  triggerToastResendVerify(message: any) {
    // console.log("message", message);
    this.toastMsgResendVerify = message;
    $('#resendVerifyErrMsg').html(message);
    setTimeout(() => {
      this.toastMsgResendVerify = "";
    }, 3000);
  }
  goToResetPassword = function (username: any) {
    // console.log('username', username);
    // window.location = "/requestResetPassword";
  };

  backToLogin() {
    // window.location = "/login";
  }
  registerUser() {
    // window.location = "/register/";
  }

  updateLanguage(lang: any) {
    this.cookieService.delete('language');
    this.cookieService.set('language', lang);
  }
  resendEmailClearFn() {
    this.resendEmailID = '';
  }
}
